/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Box, Heading, ResponsiveContext } from 'grommet'

class Section extends React.Component {
  
  render() {
    console.log(this.props.title)
    return(
      <ResponsiveContext.Consumer>
        {size => (
      <Box
        id={this.props.id}
        height={size==='small' ? "" : "100vh" }
        background={this.props.color} 
        align="center" 
        justify="center"
        animation="slideDown"
      >
        <Box 
          margin="small" 
          direction='column'
          align='center'
        >
          <Box
            align='center'
            alignContent='center'
          >
            <Heading size={size === 'small' ? 'small' : 'medium'}>
              {this.props.title}
            </Heading>
          </Box>
          <Box
            direction={size === 'small' ? 'column' : 'row'}
            alignSelf="center"
            gap="medium"
            pad='large'
            justify='center'
          >
            {this.props.children}
          </Box>
        </Box>
      </Box>
      )}
      </ResponsiveContext.Consumer>
    )
  }
}

export default Section